import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_plus",
  "use": "icon_plus-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_plus\"><path fill=\"currentColor\" d=\"M41.143 19.714H28.286V6.857A2.857 2.857 0 0025.429 4H22.57a2.857 2.857 0 00-2.857 2.857v12.857H6.857A2.857 2.857 0 004 22.571v2.858a2.857 2.857 0 002.857 2.857h12.857v12.857A2.857 2.857 0 0022.571 44h2.858a2.857 2.857 0 002.857-2.857V28.286h12.857A2.857 2.857 0 0044 25.429V22.57a2.857 2.857 0 00-2.857-2.857z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol